'use strict';

import InstructionsTranslations from './InstructionsTranslations';

export default class InstructionsTranslator {
  constructor(language) {
    this.translator = new InstructionsTranslations();
    this.language = language;
  }

  getTranslationForSegment(segment) {
    return this.translator.getByTextAndLanguage(segment.toLowerCase(), this.language);
  }

  getTranslationForText(text) {
    const segments = text.split(' ');
    const translations = segments
      .map(this.getTranslationForSegment.bind(this))
      .filter((value) => {
        return value;
      });

    return translations.join(' ').replace(/ , /g, ', ');
  }
}

module.exports = InstructionsTranslator;
